import _ from 'underscore';

/**
 * Unescape asset attribute name in form fields.
 * (Specifically, do everything underscore's _.unescape method does,
 * and also decode the HTML entities for open & close parens, if present.)
 *
 * @param {string} string Attribute name
 * @return {string} Unescaped attribute name
 */
export const unescapeAttributeName = (string: string) => {
	string = _.unescape(string);
	string = string
		.replace(/&#40;/g, '(')
		.replace(/&#41;/g, ')')
		.replace(/&#91;/g, '[')
		.replace(/&#93;/g, ']');
	return string;
};

export default unescapeAttributeName;
